module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-agency-tree-core"
  }, [_c('el-input', {
    staticClass: "search-input",
    attrs: {
      "clearable": true,
      "placeholder": "请输入机构名称"
    },
    on: {
      "input": _vm.handleFilter
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })]), _vm._v(" "), (_vm.hasFilter) ? _c('a', {
    staticClass: "more",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.handleShowMore
    }
  }, [_vm._v("更多")]) : _vm._e(), _vm._v(" "), (_vm.hasFilter) ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-tree",
    style: ({
      height: this.contentHeight + 'px'
    })
  }, [_c('div', {
    style: ({
      height: _vm.height + 'px'
    })
  }, _vm._l((_vm.visibleData), function(item, index) {
    return _c('div', {
      key: index,
      style: ({
        'padding-left': item.level * 20 + (item.children.length ? 0 : 24) + 'px',
        position: 'absolute',
        'top': item.paddingTop + 'px'
      })
    }, [_c('div', {
      staticClass: "el-tree-node__content"
    }, [(item.children.length > 0) ? _c('span', {
      staticClass: "el-tree-node__expand-icon el-icon-caret-right",
      class: {
        expanded: item.expanded
      },
      on: {
        "click": function($event) {
          _vm.handleExpand(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "el-checkbox__input",
      class: item.checkClass
    }, [_c('span', {
      staticClass: "el-checkbox__inner",
      on: {
        "click": function($event) {
          _vm.handleCheckChange(item)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-tree-node__label",
      on: {
        "click": function($event) {
          _vm.handleCheckChange(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-906d5684"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/AgencyTreeTransfer/AgencyTreeCore.vue
// module id = 758
// module chunks = 8